// extracted by mini-css-extract-plugin
module.exports = {"blockTextBig":"blockTextBig-module--blockTextBig--318N0"};